import {
  Box,
  Card,
  CardContent,
  Typography,
  Avatar,
  IconButton,
  Chip,
  Badge,
  useTheme,
} from "@mui/material";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import ArrowForwardIos from "@mui/icons-material/ArrowForwardIos";
import Logo from "../../../Assets/Images/Logo.png";

import {
  TrainingSectionAttemptStatusKey,
  TrainingModuleStatusKey,
} from "../utils/enums";

const TrainingCard = ({
  training,
  isAdmin = false,
  onClick,
  TrainingSectionAttemptStatusMap = [],
}) => {
  const statusTitle =
    TrainingSectionAttemptStatusMap?.[training?.completion_status_key];
  const statusTitleKey = training?.completion_status_key;
  const theme = useTheme();

  return (
    <Card
      variant="outlined"
      sx={{
        borderRadius: "12px",
        padding: "10px",
        border: "1px dashed",
        borderColor: theme.customColors.border.dashed,
        "&:hover": { background: theme.customColors.background.cardHeader },
        backgroundColor:
          !isAdmin &&
            statusTitleKey === TrainingSectionAttemptStatusKey.COMPLETED
            ? theme.customColors.background.hover
            : theme.customColors.background.main,
      }}
    >
      <CardContent
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Badge
            overlap="circular"
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            badgeContent={
              <Avatar
                sx={{
                  width: 20,
                  height: 20,
                  bgcolor: "primary.dark",
                  padding: "2px",
                }}
                src={Logo}
              />
            }
          >
            <Avatar
              sx={{
                bgcolor: theme.customColors.background.cardHeader,
                width: 48,
                height: 48,
                border: "1px solid",
                borderColor: theme.customColors.border.strong,
              }}
            >
              <DescriptionOutlinedIcon sx={{ color: "primary.main" }} />
            </Avatar>
          </Badge>
          <Box ml={2}>
            <Typography
              variant="h5"
              display="flex"
              alignItems="baseline"
              gap="8px"
            >
              {training?.title}
              {isAdmin ? (
                <Chip
                  label={training?.status_title}
                  size="small"
                  sx={() => {
                    switch (training?.status_key || "") {
                      case TrainingModuleStatusKey.ACTIVE:
                        return {
                          backgroundColor:
                            theme.customColors.status.completed.bg,
                          color: theme.palette.primary.light,
                          fontWeight: "500",
                        };
                      case TrainingModuleStatusKey.INACTIVE:
                        return {
                          backgroundColor: theme.customColors.status.pending.bg,
                          color: theme.customColors.status.pending.main,
                          fontWeight: "500",
                        };
                      case TrainingModuleStatusKey.DRAFT:
                      default:
                        return {
                          backgroundColor: theme.customColors.status.info.bg,
                          color: theme.customColors.button.primary,
                          fontWeight: "500",
                        };
                    }
                  }}
                />
              ) : (
                <Chip
                  label={statusTitle}
                  size="small"
                  sx={() => {
                    switch (statusTitleKey || "") {
                      case TrainingSectionAttemptStatusKey.COMPLETED:
                        return {
                          backgroundColor:
                            theme.customColors.status.completed.bg,
                          color: theme.palette.primary.light,
                          fontWeight: "500",
                        };
                      case TrainingSectionAttemptStatusKey.NOT_STARTED:
                        return {
                          backgroundColor: theme.customColors.status.pending.bg,
                          color: theme.customColors.status.pending.main,
                          fontWeight: "500",
                        };
                      case TrainingSectionAttemptStatusKey.IN_PROGRESS:
                      default:
                        return {
                          backgroundColor: theme.customColors.status.info.bg,
                          color: theme.customColors.button.primary,
                          fontWeight: "500",
                        };
                    }
                  }}
                />
              )}
            </Typography>
          </Box>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <IconButton
            sx={{
              "&:hover": {
                background: "none",
              },
            }}
            onClick={() => onClick(training)}
          >
            <ArrowForwardIos color="primary" fontSize="small" />
          </IconButton>
        </Box>
      </CardContent>
    </Card>
  );
};

export default TrainingCard;
